(function () {
  'use strict';

  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-rohpper-reveal]'));
  if (!targets.length) return;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  if (!('IntersectionObserver' in window)) {
    targets.forEach(reveal);
    return;
  }

  var pending = targets.slice();
  var rafId = null;
  var io = null;

  function teardown() {
    window.removeEventListener('scroll', schedule, true);
    window.removeEventListener('resize', onResize);
    document.removeEventListener('visibilitychange', schedule);
    if (io) {
      io.disconnect();
      io = null;
    }
  }

  function check() {
    rafId = null;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!vh) return;
    for (var i = pending.length - 1; i >= 0; i--) {
      var rect = pending[i].getBoundingClientRect();
      if (rect.top < vh * 0.9 && rect.bottom > 0) {
        reveal(pending[i]);
        pending.splice(i, 1);
      }
    }
    if (!pending.length) teardown();
  }

  function schedule() {
    if (rafId !== null) window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(check);
  }

  function scrollRoot() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return null;
    var overflowY = window.getComputedStyle(wrapper).overflowY;
    return overflowY === 'auto' || overflowY === 'scroll' ? wrapper : null;
  }

  var currentRoot;

  function buildObserver() {
    var root = scrollRoot();
    if (io && root === currentRoot) return;
    if (io) io.disconnect();
    currentRoot = root;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          var idx = pending.indexOf(entry.target);
          if (idx > -1) pending.splice(idx, 1);
        });
        if (!pending.length) teardown();
      },
      { root: root, threshold: 0.12 }
    );
    pending.forEach(function (el) {
      io.observe(el);
    });
  }

  function onResize() {
    buildObserver();
    schedule();
  }

  window.addEventListener('scroll', schedule, true);
  window.addEventListener('resize', onResize);
  document.addEventListener('visibilitychange', schedule);

  buildObserver();
  check();
})();

/* ROHPPER: autoplay fiable de los videos de fondo (hero + historia). El
   atributo autoplay del HTML no es fiable en muchos moviles; llamamos a
   play() a mano, reintentamos en varios eventos, y solo subimos la opacidad
   del video (ver rohpper-editorial.css) cuando confirmamos que esta
   reproduciendo de verdad. Si nunca arranca, la foto de fondo se queda
   visible para siempre: nunca una caja vacia. */
(function () {
  'use strict';

  function setupAutoplayVideo(video) {
    if (!video || video.dataset.rohpperAutoplayBound === '1') return;
    video.dataset.rohpperAutoplayBound = '1';

    video.muted = true;
    video.defaultMuted = true;

    function tryPlay() {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    });

    video.addEventListener('pause', function () {
      if (document.visibilityState === 'visible') tryPlay();
    });

    if (video.readyState >= 2) tryPlay();
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') tryPlay();
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryPlay();
          });
        },
        { threshold: 0.1 }
      );
      io.observe(video);
    }

    tryPlay();
  }

  function bindAll() {
    document
      .querySelectorAll('.rohpper-hero__video, .rohpper-story__video')
      .forEach(setupAutoplayVideo);
  }

  bindAll();
  new MutationObserver(bindAll).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  'use strict';

  var done = false;

  function warmVariantImages() {
    if (done) return;
    done = true;

    var imgs = document.querySelectorAll('.product-media__image[loading="lazy"]');
    Array.prototype.forEach.call(imgs, function (img) {
      img.loading = 'eager';
    });
  }

  function bind(root) {
    var picker = (root || document).querySelector('variant-picker');
    if (!picker || picker.dataset.rohpperWarm === '1') return;
    picker.dataset.rohpperWarm = '1';

    picker.addEventListener('pointerenter', warmVariantImages, { once: true, passive: true });
    picker.addEventListener('touchstart', warmVariantImages, { once: true, passive: true });
    picker.addEventListener('focusin', warmVariantImages, { once: true });
  }

  bind(document);

  document.addEventListener('variant:update', function () { bind(document); });
  new MutationObserver(function () { bind(document); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
